import { connect }                  from 'react-redux';
import { Dispatch }                 from "redux";

import {
         langType,
         modalStateType,
         userInfoType,
       }                            from 'types'

import { LOG_OUT_SAGA }             from 'actions';

import { ActionTypes }              from 'actions/types';
import { reducerType }              from 'reducer';

import { words }                    from 'utils/dictionary';

import { colors }                   from 'utils/colors'
//import logo                         from 'images/yisumaticaLogo.png';
import { makeStyles }               from "makeStyles";
import { SET_MODAL_STATE }          from 'actions/modalActions';
import WhatsappLink                 from '../WhatsappLink';
import getSemelFromUserInfo         from 'utils/getSemelFromUserInfo';


const logo  = 'https://www.yisumatica.org.il/yisumaticaImages/yisumaticaLogo.png';


const useStyles = makeStyles()(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.6s',
    },
    semel: {
      fontWeight:  600,
      fontSize:    20,
      marginBottom: 16,
    },
    DenyAccess: {
      position:        'fixed',
      top:             0,
      left:            0,
      minHeight:       '100vh',
      minWidth:        '100vw',
      maxHeight:       '100vh',
      maxWidth:        '100vw',
      backgroundColor: '#FFF',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
    },
    loading: {
      fontWeight:  'bold',
      fontSize:     27,
      marginBottom: 40
    },
    denyAccess: {
      fontWeight:  'bold',
      fontSize:     22,
      marginBottom: 8
    },
    submitButton: {
      width:           200,
      height:          35,
      fontSize:        20,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: colors.primary,
      color:           '#FFF',
      fontWeight:      'bold',
      cursor:          'pointer',
      boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
      left:            '50%',
      marginTop:       20,
      marginLeft:      8,
      marginRight:     8,
      '&:hover': {
        opacity: 0.5
      }
    },
    positionAbsolute: {
      position:  'absolute',  
      transform: 'translate(-50%, 0%)',
    },
    logo: {
      width:              200,
      height:             100,
      backgroundImage:    `url(${ logo })`,
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
    buttonContainer: {
      width:          '100%',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center'
    },
    transformLogo: {
      transform: 'translate(0px, -120px)',
    },
    fallBack: {
    },
}))

type DenyAccessProps = {
  lang:               langType;
  logOut:             () => void,
  setModalState:      (payload: modalStateType) => void;
  userInfo:           userInfoType;
}

const DenyAccess: React.FC<DenyAccessProps> = ({
  lang,
  logOut,
  setModalState,
  userInfo
}) => {

const { classes } = useStyles();


  const semelMosad = getSemelFromUserInfo(userInfo);

  return (
          <div className = { classes.DenyAccess }>
            {
              semelMosad && (
                <div className={classes.semel} dir='rtl'>
                  {`סמל מוסד: ${ semelMosad }`}
                </div>
              )
            }
            {
              ['userNotSubscribed', 'emailGali', 'betterCallGali'].map((val) => {
                return(
                  <div 
                    key       = {`${ val }denyAccess:::`}
                    className = { classes.denyAccess } 
                    dir       = 'rtl'
                  >
                    { words[val][lang] }
                  </div>
                )
              })
            }
              <WhatsappLink variant = '' />
              <div className = { classes.buttonContainer } >
                  <div
                    dir       = 'rtl'
                    className = { classes.submitButton }
                    onClick   = { logOut }
                  >
                      { words['signOut'][lang] }
                  </div>
                  <div
                    dir       = 'rtl'
                    className = { classes.submitButton }
                    onClick   = { () => { setModalState({ modalVariant: 'showUserInfo', showModal: true }) } }
                  >
                      { words['showDetails'][lang] }
                  </div>
              </div>
          </div>
  );
}




const mapStateToProps = (reducer: reducerType) => {
  return {
    lang: reducer.components.lang,
    userInfo: reducer.data.userInfo,
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
    logOut:        () => dispatch(LOG_OUT_SAGA()),
    setModalState: (payload: modalStateType) => dispatch(SET_MODAL_STATE(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(DenyAccess);
